module.exports = __webpack_public_path__ + "static/media/purple-timer.704efa3d.png";